import { Guttagekonto } from '@/domain/mitarbeiter/features/guttagekonto/shared/entities/Guttagekonto';
import { GetMitarbeiterGuttagekontoByIdDocument } from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';

export function useGuttagekonto(
  ids: string[],
  jahr: number,
): {
  guttagekonto: Guttagekonto;
} {
  const { data, error } = useSuspenseQuery(
    GetMitarbeiterGuttagekontoByIdDocument,
    {
      variables: { ids, jahr },
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
  );
  const result = data?.mitarbeiter_mitarbeiterByIds[0];

  if (error || !data) {
    Sentry.captureException(error);
    return {
      guttagekonto: null,
    };
  }

  const guttagekontoResult: Guttagekonto = {
    mitarbeiter: {
      uid: result.uid,
      vorname: result.vorname,
      nachname: result.nachname,
    },
    jahr: result.guttagekonto.jahr,
    ausgezahlteGuttage: result.guttagekonto.ausgezahlteGuttage,
    gegebeneGuttage: result.guttagekonto.gegebeneGuttage,
    genommeneGuttage: result.guttagekonto.genommeneGuttage,
    istStand: result.guttagekonto.istStand,
    uebertragAusVorjahr: result.guttagekonto.uebertragAusVorjahr,
  };

  return {
    guttagekonto: guttagekontoResult,
  };
}
